import React, {FunctionComponent} from "react";
import './HeroCarouselScrollSymbol.scss';

interface HeroCarouselScrollIconProps {
}

const HeroCarouselScrollSymbol: FunctionComponent<HeroCarouselScrollIconProps> = () => {
    return (
        <div className='scroll-symbol'>
            <div className="mouse-scroll">
                <span className="mouse">
                    <span className="mouse-movement">
                    </span>
                </span>
            </div>
        </div>
    )
}

export default HeroCarouselScrollSymbol;
